'use strict';

/* global $ */

function Questions(options) {

    let opt = $.extend({
        item: options.selector+'__item',
        question: options.selector+'__item-question',
        answer: options.selector+'__item-answer',
    }, options);

    function initBlock(el) {

        console.log('[ Questions/Init ]');

        let $el = $(el);

        $el.find(opt.question).on('click', function(e) {
            e.preventDefault();
            console.log('[ Questions/ Item toggle ]');
            $el.find(opt.answer).slideToggle();
        });
    }

    $(opt.item).each(function() {
        initBlock(this);
    });
}

export {
    Questions
};
